import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { withdrawalRequestsApi } from 'api/withdrawalRequests'
import { EWithdrawalRequestStatus } from 'models/withdrawalRequest'
import { IWithdrawalRequestsState } from './types'

const initialState: IWithdrawalRequestsState = {
  pendingCount: 0
}

// «Ожидает вывода» заявки получают с 11-го и 26-го, когда закрывается расчётный период,
// и держат до выплаты — бейдж напоминает о выплатах, а не о новых подачах
export const getPendingWithdrawalRequests = createAsyncThunk(
  'withdrawalRequests/getPending',
  async () => {
    const response = await withdrawalRequestsApi.getList({
      skip: '0',
      limit: '1',
      status: EWithdrawalRequestStatus.PENDING
    })
    return response.data.count
  }
)

const withdrawalRequestsSlice = createSlice({
  name: 'withdrawalRequests',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPendingWithdrawalRequests.fulfilled, (state, action) => {
        state.pendingCount = action.payload
      })
      .addCase('app/logout', () => initialState)
  }
})

export default withdrawalRequestsSlice.reducer
